import { jeepRallyApi } from "../api";

const rallyBaseUrl = "/api/v1/rally";
const registrationsBaseUrl = "/api/v1/registrations";

export const getRegistrationsByEvent = (eventId, params = {}) => {
  const query = {};
  if (params.category_id) query.category_id = params.category_id;
  if (params.status) query.status = params.status;
  return jeepRallyApi.get(`${rallyBaseUrl}/${eventId}/registrations`, {
    params: query,
  });
};

export const getRegistrationById = (id) => {
  return jeepRallyApi.get(`${registrationsBaseUrl}/${id}`);
};

export const updateCompetitorApproval = (id, status) => {
  return jeepRallyApi.patch(
    `${registrationsBaseUrl}/${id}/competitor-approval`,
    { status }
  );
};
